export default __webpack_public_path__ + "static/media/lisieux14.ce2f735a.jpg";